import { InjectionToken } from "@angular/core";

export const WEB_PUSH_ENABLED = new InjectionToken<boolean>('WEB_PUSH_ENABLED');
export const WEB_PUSH_VAPID_PUBLIC_KEY = new InjectionToken<string>('WEB_PUSH_VAPID_PUBLIC_KEY');
